module.exports = __webpack_public_path__ + "static/media/portfolio11.40c547c5.jpg";